/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fac_Plan_CtaInputs */

const en_fac_plan_cta = /** @type {(inputs: Fac_Plan_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Facilitator`)
};

const id_fac_plan_cta = /** @type {(inputs: Fac_Plan_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ambil Fasilitator`)
};

/**
* | output |
* | --- |
* | "Get Facilitator" |
*
* @param {Fac_Plan_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fac_plan_cta = /** @type {((inputs?: Fac_Plan_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fac_Plan_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fac_plan_cta(inputs)
	return en_fac_plan_cta(inputs)
});